import { ButtonHTMLAttributes, FC } from 'react'
import { ToolbarButton } from './ToolbarButton'
import SvgDownload from '../../components/icons/Download'
import './ToolbarDownloadButton.scss'

export const ToolbarDownloadButton: FC<ButtonHTMLAttributes<HTMLButtonElement>> = ({ className, ...attrs }) => {
  return (
    <ToolbarButton className="ToolbarDownloadButton" icon={<SvgDownload />} hotkey="Export file" {...attrs}>
      Download
    </ToolbarButton>
  )
}
